var _rect, _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3, _path7, _path8, _path9, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsSliders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#bac2ff",
    height: 478.44,
    rx: 41.24,
    width: 478.44,
    x: 16.78,
    y: 16.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m495.22 454v-24.77a41.24 41.24 0 0 1 -41.22 41.24h-396a41.24 41.24 0 0 1 -41.25-41.23v24.76a41.25 41.25 0 0 0 41.25 41.22h396a41.24 41.24 0 0 0 41.22-41.22z",
    fill: "#8c9aff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m211.87 140.52h217.36a16.5 16.5 0 0 0 0-33h-346.46a16.5 16.5 0 1 0 0 33z",
    fill: "#bac2ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.26,
    cy: 124.02,
    fill: "#bac2ff",
    r: 49.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m214.76 124a49.75 49.75 0 0 0 -1.65-12.38 49.43 49.43 0 0 1 -95.74 0 49.5 49.5 0 1 0 97.39 12.38z",
    fill: "#8c9aff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m211.87 404.48h217.36a16.5 16.5 0 0 0 0-33h-346.46a16.5 16.5 0 1 0 0 33z",
    fill: "#bac2ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.26,
    cy: 387.98,
    fill: "#bac2ff",
    r: 49.49
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m214.76 388a49.67 49.67 0 0 0 -1.65-12.37 49.43 49.43 0 0 1 -95.74 0 49.49 49.49 0 1 0 97.39 12.37z",
    fill: "#8c9aff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m300.13 239.5h-217.36a16.5 16.5 0 1 0 0 33h346.46a16.5 16.5 0 0 0 0-33z",
    fill: "#bac2ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.74,
    cy: 256,
    fill: "#bac2ff",
    r: 49.49
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m396.23 256a49.21 49.21 0 0 0 -1.65-12.37 49.43 49.43 0 0 1 -95.74 0 49.49 49.49 0 1 0 97.39 12.37z",
    fill: "#8c9aff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.78 58v24.77a41.24 41.24 0 0 1 41.22-41.24h396a41.24 41.24 0 0 1 41.25 41.23v-24.76a41.25 41.25 0 0 0 -41.25-41.22h-396a41.24 41.24 0 0 0 -41.22 41.22z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m454 8.53v16.47h-66v-16.47z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#27227d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 420.98,
    cy: 16.78,
    r: 8.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.53 58v396a49.55 49.55 0 0 0 49.47 49.47h396a49.55 49.55 0 0 0 49.5-49.47v-396a49.56 49.56 0 0 0 -49.5-49.47 8.25 8.25 0 0 0 0 16.47 33 33 0 0 1 33 33v396a33 33 0 0 1 -33 33h-396a33 33 0 0 1 -33-33v-396a33 33 0 0 1 33-33h330a8.25 8.25 0 0 0 0-16.5h-330a49.56 49.56 0 0 0 -49.47 49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.62 141.55a24.27 24.27 0 0 0 7.38-17.55 24.75 24.75 0 0 0 -24.74-24.75h-211.91a57.62 57.62 0 0 0 -104.18 0h-30.4a24.75 24.75 0 0 0 0 49.49h30.4a57.61 57.61 0 0 0 104.18 0h211.88a24.13 24.13 0 0 0 17.39-7.21zm-17.39-25.78a8.25 8.25 0 0 1 8.25 8.25 8 8 0 0 1 -2.53 5.87 7.89 7.89 0 0 1 -5.72 2.38h-206.89a51.89 51.89 0 0 0 0-16.5zm-346.46 16.5a8.25 8.25 0 1 1 0-16.5h25.41a51.89 51.89 0 0 0 0 16.5zm82.49 33a41.25 41.25 0 1 1 41.25-41.27 41.25 41.25 0 0 1 -41.25 41.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.62 405.52a24.24 24.24 0 0 0 7.38-17.52 24.74 24.74 0 0 0 -24.74-24.74h-211.91a57.61 57.61 0 0 0 -104.18 0h-30.4a24.75 24.75 0 0 0 0 49.49h30.4a57.62 57.62 0 0 0 104.18 0h211.88a24.13 24.13 0 0 0 17.39-7.21zm-17.39-25.79a8.27 8.27 0 0 1 8.25 8.25 8.09 8.09 0 0 1 -2.53 5.88 7.93 7.93 0 0 1 -5.72 2.37h-206.89a51.89 51.89 0 0 0 0-16.5zm-346.46 16.5a8.25 8.25 0 1 1 0-16.5h25.41a51.89 51.89 0 0 0 0 16.5zm82.49 33a41.25 41.25 0 1 1 41.25-41.23 41.24 41.24 0 0 1 -41.25 41.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454 256a24.75 24.75 0 0 0 -24.74-24.75h-30.4a57.62 57.62 0 0 0 -104.18 0h-211.91a24.75 24.75 0 1 0 0 49.5h211.88a57.62 57.62 0 0 0 104.18 0h30.4a24.75 24.75 0 0 0 24.77-24.75zm-24.74-8.25a8.25 8.25 0 0 1 0 16.5h-25.44a51.89 51.89 0 0 0 0-16.5zm-346.49 16.5a8 8 0 0 1 -5.87-2.53 7.89 7.89 0 0 1 -2.38-5.72 8.25 8.25 0 0 1 8.25-8.25h206.89a51.89 51.89 0 0 0 0 16.5zm264 33a41.24 41.24 0 1 1 41.23-41.25 41.24 41.24 0 0 1 -41.23 41.25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSliders);
export default __webpack_public_path__ + "static/media/settingsSliders.50abfcef7c6106b882069e4de6383382.svg";
export { ForwardRef as ReactComponent };